import {Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { ValidatorUtils } from '../../../shared/utils/src/validator.utils';
import { StringUtils} from '../../../shared/utils/src/string.utils';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
@Component({
    selector: 'suppression-rule-component',
    templateUrl: './suppression-rule.component.html'
})

export class SuppressionRuleComponent implements OnInit, OnDestroy, OnChanges, OnDestroy {
    @Input() msgSpecSelectConfig: any;
    @Input() timeTypeSelectConfig: any;
    @Input() public ruleInfo = [];
    @Input() public isEditable: boolean;
    @Input() public setMsgSpecCheckFlag = false;
    @Output() public routeNotUse: EventEmitter<any> = new EventEmitter();

    isInvalid = false;
    isNotCheckedMsgSpec: boolean;
    isEmptySuppTime: boolean;

    public msgSpecCount = 0;

    ruleIndex = 0;

    public isNullSuppressionCnd = false;
    public isNullSuppressionTime = false;

    // private subscription: Subscription;
    private langSubscription: Subscription;

    isAllChecked: boolean;

    msg_MK00843 = '';
    MsgSpecFlag = false;
    MsgSpec = '';

    constructor(private dragulaService: DragulaService,
                private translateService: TranslateService) {

        this.msg_MK00843 = this.translateService.instant('MK.00843');
        dragulaService.drop.subscribe((value: any) => {
            if (value[0] === 'suppressionRule') {
                this.resetOrdrNo();
            }
        });

        dragulaService.setOptions('suppressionRule', {
            moves: function (el, container, handle) {
                return handle.className === 'dragable_button dragable_flag';
            }
        });


        // this.subscription = Observable.fromEvent(document, 'click')
        //     .subscribe( (event: Event) => this.clickHandler(event) );
    }

    ngOnInit() {
        this.langSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.msg_MK00843 = this.translateService.instant('MK.00843');
        });
    }


    ngOnChanges(changes: SimpleChanges) {
        this.isNullSuppressionCnd = false;
        this.isNullSuppressionTime = false;

        const isEditableChange = changes['isEditable'];

        if (isEditableChange && this.isEditable) {
            this.resetSuppressionRuleID();

            if (this.ruleInfo.length === 0) {
                this.ruleSetAdd();
            }

            if (this.setMsgSpecCheckFlag) {
                this.setMsgSpecCheck(this.ruleInfo);
            }
        }
    }

    ngOnDestroy() {
        this.dragulaService.destroy('suppressionRule');
        // this.subscription.unsubscribe();
        this.langSubscription.unsubscribe();
    }

    public ruleSetAdd() {
        this.ruleIndex++;
        this.ruleInfo.push({
            'ordrNo': this.ruleIndex,
            'suppTime': ''
        });

        this.resetSuppressionRuleID();
    }


    public ruleSetRemove(event, ordrNo) {
        _.remove(this.ruleInfo, {ordrNo : ordrNo});

        this.resetOrdrNo();
    }

    public resetOrdrNo() {
        this.ruleIndex = 0;

        this.ruleInfo.forEach((ruleSet, index) => {
            index++;
            ruleSet.ordrNo = index;
            this.ruleIndex = index;
        });

        if (this.ruleIndex === 0) {
            this.routeNotUse.emit('suppression');
        }
    }

    public resetSuppressionRuleID() {
        $('#suppressionRule tbody tr').each(function (_index) {
            $(this).find('#msgSpecList > li').each(function (_ind) {
                $(this).find('input:checkbox[name="msgSpec"]').attr('id', _index + 'msgSpec' + _ind).next().attr('for', _index + 'msgSpec' + _ind);
                //$(this).find('label').first().attr('for', _index + 'msgSpec' + _ind);
            });

            //1차에서 빠짐 $(this).find('input:checkbox[name="suppRepeatFlag"]').attr('id', 'suppRepeatFlag' + _index).next().attr('for', 'suppRepeatFlag' + _index);


            //$(this).find('label').first().attr('for', 'suppRepeatFlag' + _index);
        });
    }



    public setSuppMsgSpec(event) {
        let target = event.target.parentElement.parentElement;
        let MsgSpec = '';

        let _msgSpecCount = 0;
        $(target).find('li > input:checkbox[name="msgSpec"]').each(function (_ind) {
            if ($(this).is(':checked')) {
                if (_msgSpecCount !== 0) {
                    MsgSpec += ' , ';
                }

                _msgSpecCount++;
                MsgSpec += '<span>' + $(this).next('label').text() + '</span>';
            }
        });
        this.isNotCheckedMsgSpec = _msgSpecCount > 0 ? false : true;
        this.msgSpecCount = _msgSpecCount;
        target = target.parentElement;
       /* if (MsgSpec === '') {
            MsgSpec = '<span style="color:#999">Select one at least</span>';
        }
        $(target).find('button').html(MsgSpec);*/

        if (MsgSpec === '') {
            this.MsgSpecFlag = false;
        } else {
            this.MsgSpecFlag = true;
            this.MsgSpec = MsgSpec;
        }

        this.isAllCheck();
    }

    public suppMsgSpecAllChange(event) {
        if (event.target.checked) {
            $('input:checkbox[name="msgSpec"]').prop('checked', true);

        } else {
            $('input:checkbox[name="msgSpec"]').prop('checked', false);
        }

        this.setSuppMsgSpec(event);
    }

    public getRuleInfo(): any {
        const _suppressionRuleInfo = [];
        $('#suppressionRule tbody tr').each(function (_index) {

            const _msgSpecFildList = [];

            $(this).find('#msgSpecList > li').each(function () {
                $(this).find('input:checkbox[name="msgSpec"]').each(function () {
                    if ($(this).is(':checked')) {
                        _msgSpecFildList.push({msgSpecFildNo: $(this).val() });
                    }
                });
            });


            let suppTime = $(this).find('#suppTime').val();

            /*let suppRepeatFlag = 'N';
            if ($(this).find('input:checkbox[name="suppRepeatFlag"]').first().is(':checked')) {
                suppRepeatFlag = 'Y';
            }*/

            const timeType = $(this).find('#timeType').val();
            if (timeType === 'min') {
                suppTime = suppTime * 60;
            } else if (timeType === 'hour') {
                suppTime = suppTime * 60 * 60;
            } else if (timeType === 'day') {
                suppTime = suppTime * 60 * 60 * 24;
            }

            const suppRepeat = $(this).find('#suppRepeat').val();

            const cndVal = `${suppTime}::${suppRepeat}`;

            const suppressionRule = {
                ordrNo: _index + 1,                                         //룰셋팅 순번
                cndCnnTypeCd: _index === 0 ? 'RUCDCN10' : 'RUCDCN20', //첫번째룰은 if 두번째룰은 else if
                msgSpecFildList: _msgSpecFildList,
                msgSpecFildNo: '0',
                oprTypeCd: 'COPR010',                                    // 서프레션룰은  isequal로 판단하여 처리함. $(this).find('#oprTypeList option:selected').val(),
                cndVal: cndVal,                 //"120::4"   시간:사용여부:4
                cndValAryYn: 'Y',
                cndValSprtnChaVal: '::',
                routTrgtNo: '10001'             //테스트를 위하여 임의로 10001     등록함
            };
            _suppressionRuleInfo.push(suppressionRule);
        });

        return _suppressionRuleInfo;
    }

    // private clickHandler(event: Event): void {
    //     const targetElement = event.srcElement;
    //
    //     $('[name=suppMsgSpecSection]').each(function (_index) {
    //         const nativeElement = $(this).get(0);
    //
    //         if (nativeElement === targetElement || nativeElement.contains(targetElement)) {
    //             $(this).addClass('expand');
    //         }else {
    //             $(this).removeClass('expand');
    //         }
    //
    //     });
    //
    // }

    toggleButton(event) {
        event.preventDefault();
        event.stopPropagation();
        const $section = $('#suppMsgSpecSection');
        if ($section.hasClass('expand')) {
            $section.removeClass('expand');
        } else {
            $section.addClass('expand');
        }
    }

    clickedOutside() {
        $('#suppMsgSpecSection').removeClass('expand');
    }

    setMsgSpecCheck(ruleInfo) {
        let _msgSpecCount = 0;
        let MsgSpec = '';
        $('#suppressionRule tbody tr').each(function (i) {

            _msgSpecCount = 0;
            $(this).find('#msgSpecList > li').each(function () {
                $(this).find('input[name="msgSpec"]').each(function (j) {
                    const _val = $(this).val();
                    ruleInfo[i].msgSpecFildList.forEach((msgSpec: any) => {
                        if (_val === msgSpec.msgSpecFildNo.toString()) {

                            $(this).attr('checked', true);
                            if (_msgSpecCount !== 0) {
                                MsgSpec += ' , ';
                            }

                            _msgSpecCount++;
                            MsgSpec += '<span>' + msgSpec.msgSpecFildNm + '</span>';
                        }
                    });
                });
            });

            //$(this).find('button').html(MsgSpec);
        });


        if (MsgSpec === '') {
            this.MsgSpecFlag = false;
        }else {
            this.MsgSpecFlag = true;
            this.MsgSpec = MsgSpec;
        }

        this.isAllCheck();
    }

    public validation() {
        let _msgSpecCount = 0;
        let  suppTime = '';
        $('#suppressionRule tbody tr').each(function (i) {
            if (i === 0) {
                _msgSpecCount = 0;
                $(this).find('#msgSpecList > li > input[name="msgSpec"]').each(function () {
                    if ($(this).is(':checked')) {
                        _msgSpecCount++;
                    }
                });

                suppTime = $(this).find('#suppTime').val();
            }
        });
        let suppressionValidation = true;

        this.isNotCheckedMsgSpec = false;
        this.isEmptySuppTime = false;

        if (_msgSpecCount === 0 ) {
            this.isNotCheckedMsgSpec = true;
        }

        if (StringUtils.isEmpty(suppTime.trim())) {
            this.isEmptySuppTime = true;
        }

        if( this.isNotCheckedMsgSpec || this.isEmptySuppTime ) {
            suppressionValidation = false;
        }

        return suppressionValidation;
    }

    onlyNumber(event) {
        return ValidatorUtils.onlyNumber(event);
    }

    removeChar(event) {
        this.suppTimeValid(event);
        ValidatorUtils.removeChar(event);
    }

    checkMinMax(event) {
        ValidatorUtils.checkNumberValidation(event);
    }

    suppTimeValid(event) {
        if (event.code.indexOf('Digit') > -1) {
            this.isEmptySuppTime = false;
        }
    }

    isAllCheck() {
        if ($('input:checkbox[name=msgSpec]').length !== 0 &&
                $('input:checkbox[name=msgSpec]').length === $('input:checkbox[name=msgSpec]:checked').length) {
            this.isAllChecked =  true;
        } else {
            this.isAllChecked =  false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/suppression-rule/suppression-rule.component.ts